export const trackEvent = (eventType, category, extraProps) => {
  window.dataLayer.push({
    event: eventType.replace(/_/g, " "),
    category,
    ...(extraProps || {})
  });
};